import { gql } from '@apollo/client';

export const COMPANY_CONTACTS_PAGE_QUERY = gql`
  query companyContacts(
    $limit: Int!
    $offset: Int!
    $companyId: Int
    $q: String
    $withDeleted: Boolean
    $orderBy: String
    $orderDirection: String
    $columnFilters: [ColumnFilter!]
  ) {
    companyContacts(
      limit: $limit
      offset: $offset
      companyId: $companyId
      q: $q
      withDeleted: $withDeleted
      orderBy: $orderBy
      orderDirection: $orderDirection
      columnFilters: $columnFilters
    ) {
      id
      companyId
      hasDraft
      currentVersion {
        deletedAt
        assistantName
        assistantPhone
        businessUnitId
        userId
        companyContactId
        createdById
        departmentId
        directWorkPhone
        doNotCall
        emailOptOut
        fax
        firstName
        homePhone
        id
        lastName
        localFirstName
        localLastName
        localMiddleName
        mailingAddressLine1
        mailingAddressLine2
        mailingCountryId
        mailingPoZipCode
        mailingStateProvinceId
        middleName
        mobilePhone
        notes
        otherAddressLine1
        otherAddressLine2
        otherCity
        otherCountryId
        otherPhone
        otherPoZipCode
        otherStateProvinceId
        personalEmail
        preferredLanguageId
        receiveAbbreviatedReportPdf
        receiveArtifactsAsLinks
        receiveFinalReportPdf
        receiveInvoice
        receiveQuote
        salutation
        status
        suffix
        title
        updatedById
        version
        workEmail
        reportContacts {
          id
        }
        results {
          id
        }
      }
    }
    companyContactsPageInfo(
      companyId: $companyId
      q: $q
      columnFilters: $columnFilters
      withDeleted: $withDeleted
    ) {
      totalCount
    }
  }
`;

export const COMPANY_CONTACTS_QUERY = gql`
  query companyContacts(
    $limit: Int!
    $offset: Int!
    $companyId: Int
    $q: String
  ) {
    companyContacts(
      limit: $limit
      offset: $offset
      companyId: $companyId
      q: $q
    ) {
      id
      companyId
      hasDraft
      currentVersion {
        assistantName
        assistantPhone
        businessUnitId
        userId
        companyContactId
        createdById
        departmentId
        directWorkPhone
        doNotCall
        emailOptOut
        fax
        firstName
        homePhone
        id
        lastName
        localFirstName
        localLastName
        localMiddleName
        mailingAddressLine1
        mailingAddressLine2
        mailingCountryId
        mailingPoZipCode
        mailingStateProvinceId
        middleName
        mobilePhone
        notes
        otherAddressLine1
        otherAddressLine2
        otherCity
        otherCountryId
        otherPhone
        otherPoZipCode
        otherStateProvinceId
        personalEmail
        preferredLanguageId
        receiveAbbreviatedReportPdf
        receiveArtifactsAsLinks
        receiveFinalReportPdf
        receiveInvoice
        receiveQuote
        salutation
        status
        suffix
        title
        updatedById
        version
        workEmail
        reportContacts {
          id
        }
        results {
          id
        }
      }
    }
  }
`;

export const COMPANY_CONTACT_QUERY = gql`
  query companyContact($id: Int!) {
    companyContact(id: $id) {
      id
      companyId
      currentVersion {
        deletedAt
        assistantName
        assistantPhone
        businessUnitId
        userId
        companyContactId
        createdById
        departmentId
        directWorkPhone
        doNotCall
        emailOptOut
        fax
        firstName
        homePhone
        id
        lastName
        localFirstName
        localLastName
        localMiddleName
        mailingAddressLine1
        mailingAddressLine2
        mailingCountryId
        mailingPoZipCode
        mailingStateProvinceId
        middleName
        mobilePhone
        notes
        otherAddressLine1
        otherAddressLine2
        otherCity
        otherCountryId
        otherPhone
        otherPoZipCode
        otherStateProvinceId
        personalEmail
        preferredLanguageId
        receiveAbbreviatedReportPdf
        receiveArtifactsAsLinks
        receiveFinalReportPdf
        receiveInvoice
        receiveQuote
        salutation
        status
        suffix
        title
        updatedById
        version
        workEmail
        reportContacts {
          id
        }
        results {
          id
        }
      }
    }
  }
`;

export const COMPANY_CONTACT_VERSIONS_QUERY = gql`
  query companyContactVersions($companyContactId: Int!) {
    companyContactVersions(companyContactId: $companyContactId) {
      deletedAt
      assistantName
      assistantPhone
      businessUnitId
      userId
      companyContactId
      createdAt
      createdById
      departmentId
      directWorkPhone
      doNotCall
      emailOptOut
      fax
      firstName
      homePhone
      id
      lastName
      localFirstName
      localLastName
      localMiddleName
      mailingAddressLine1
      mailingAddressLine2
      mailingCountryId
      mailingPoZipCode
      mailingStateProvinceId
      middleName
      mobilePhone
      notes
      otherAddressLine1
      otherAddressLine2
      otherCity
      otherCountryId
      otherPhone
      otherPoZipCode
      otherStateProvinceId
      personalEmail
      preferredLanguageId
      receiveAbbreviatedReportPdf
      receiveArtifactsAsLinks
      receiveFinalReportPdf
      receiveInvoice
      receiveQuote
      salutation
      status
      suffix
      title
      updatedAt
      updatedById
      version
      workEmail
      reportContacts {
        id
      }
      results {
        id
      }
    }
  }
`;

export const JOB_COMPANY_CONTACTS = gql`
  query jobCompanyContacts($jobId: [Int!]!, $serviceType: ExternalStakeholderServiceTypeEnum!, $withExistingContest: Boolean) {
    jobCompanyContacts(jobId: $jobId, serviceType: $serviceType, withExistingContest: $withExistingContest) {
      id
      company {
        currentVersion {
          code
          companyContacts {
            id
            currentVersion {
              id
              firstName
              lastName
              userId
              workEmail
            }
          }
          companyTypes {
            id
            currentVersion {
              id
              description
              name
            }
          }
          displayName
          mainEmail
          name
        }
      }
      companyId
      currentVersion {
        id
        firstName
        lastName
        userId
        workEmail
      }
    }
  }
`;
